import { Helmet } from 'react-helmet-async';
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid } from '@mui/material';
import Iconify from '../components/iconify';
import axios from "axios";

import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  InputLabel,
  FormControl,
  Select,
  TextField
} from '@mui/material';

import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  
  const [accountants, setAccountants] = useState('');
  
  const [accountantsdataloaded, setAccountantsDataLoaded] = useState(false);
	
  const { user: currentUser } = useSelector((state) => state.auth);

  const theme = useTheme();
  
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  useEffect(() => {  
	if (!accountantsdataloaded) {
	  getAccountants();
	}
  },[accountantsdataloaded]);
  
  const getAccountants = async () => {
	  console.log(process.env); 
      try { 
        const response = await axios.get(SERVER_URL + "/accountants");
        setAccountants(response.data);
		setAccountantsDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };

  if (!currentUser) {
    return <Navigate to="/login" />;
  }
    
  return (
    <>
      <Helmet>
        <title> GPS Dogs Tracking System </title>
      </Helmet>

	  {accountantsdataloaded && (
      <Container maxWidth="xl">
		<Card> 
        {accountants.map((row) => {
        const { id, ime, prezime, mjesto, drzava, counthuntergps, counttkstar909, counttkstar909B, counticar122, counticar122pro, counttopin, countmicodus, countold, countnew, countbih, countsrbija, countcrnagora, countostali } = row; 

        return (
		<li key = {id}>
		<Card>
			<Typography variant="subtitle2" noWrap>
				Accountant: {id}. {ime} {prezime}, {mjesto}, {drzava}
			</Typography>
		</Card>	
		
		<Card>
		<Grid container spacing={3}>
		  <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits
              title="Modeli"
              chartData={[
                { label: 'Hunter GPS', value: counthuntergps },
				{ label: 'TKStar909', value: counttkstar909 },
                { label: 'TKStar909B', value: counttkstar909B },
                { label: 'Icar122', value: counticar122 },
				{ label: 'Icar122Pro', value: counticar122pro },
                { label: 'Topin', value: counttopin },
                { label: 'Micodus', value: countmicodus },
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.info.main,
                theme.palette.warning.main,
                theme.palette.error.main,
              ]}
            />
          </Grid>
		  
		  <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits
              title="Stari / Novi"
              chartData={[
                { label: 'Stari', value: countold },
				{ label: 'Novi', value: countnew },
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.warning.main,
              ]}
            />
          </Grid>	
		  
		  <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits
              title="Države"
              chartData={[
                { label: 'Bosna i Hercegovina', value: countbih },
				{ label: 'Srbija', value: countsrbija },
                { label: 'Crna Gora', value: countcrnagora },
                { label: 'Ostali', value: countostali }
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.info.main,
                theme.palette.warning.main,
                theme.palette.error.main,
              ]}
            />
          </Grid>
		</Grid>	
		</Card>
						
		<br />				
		</li>
		);
		})}
    <br />
		</Card>
		<br />
      </Container>
	  )}
    </>
  );
}
